import {Component, Input, OnInit} from '@angular/core';
export type ApplicationFormType = 'drug' | 'vaccine';
@Component({
    selector: 'app-timeline-tile',
    standalone: true,
    imports: [],
    templateUrl: './timeline-tile.component.html',
    styleUrl: './timeline-tile.component.scss'
})
export class TimelineTileComponent implements OnInit {
    @Input() eventName!: string;
    @Input() quantity!: string;
    @Input() dayNumber!: string;
    @Input() applyMethod!: string;
    @Input() assignedTo!: string;
    @Input() applicationForm!: ApplicationFormType;

    imageUrl: string = '';
    imageAlt: string = '';
    ngOnInit() {
        this.setImageBasedOnForm();
    }

    setImageBasedOnForm(): void {
        if (this.applicationForm === 'vaccine') {
            this.imageUrl = '/assets/img/vaccine.svg';
            this.imageAlt = 'Vaccine Icon';
        } else {
            this.imageUrl = '/assets/img/drug.svg';
            this.imageAlt = 'Drug Icon';
        }
    }
}
